webpackJsonp([58308676151394],{

/***/ 367:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3738:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bg.0e30cb95.svg";

/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.innerWrapperStyle = exports.wrapperStyle = exports.cardsSectionStyle = exports.cardsWrapStyle = exports.textStyle = exports.titleStyle = undefined;
	
	var _after, _css, _css2;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _bg = __webpack_require__(3738);
	
	var _bg2 = _interopRequireDefault(_bg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingXLarge, /*#__PURE__*/(0, _emotion.css)({
		maxWidth: '800px',
		marginBottom: '24px'
	}));
	
	var textStyle = exports.textStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		maxWidth: '800px',
		marginBottom: '15px'
	}));
	
	var cardsWrapStyle = /*#__PURE__*/exports.cardsWrapStyle = (0, _emotion.css)({
		position: 'relative',
	
		'&:after': (_after = {
			position: 'absolute',
			top: '0',
			left: '0',
			borderRadius: '0 8px 8px 0',
			width: '55%',
			height: 'calc(100% - 25px)',
			background: '#f6f6f6',
			content: '" "',
			display: 'block'
		}, _after['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
			top: '25px'
		}, _after)
	});
	
	var cardsSectionStyle = exports.cardsSectionStyle = (0, _emotion.cx)((0, _globalStyles.cardSection)(), /*#__PURE__*/(0, _emotion.css)((_css = {
		maxWidth: '700px',
		position: 'relative',
		zIndex: '2',
		top: '-50px'
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		top: '0'
	}, _css)));
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)((_css2 = {
		paddingBottom: '178px',
		background: 'transparent url(' + _bg2.default + ') no-repeat bottom right'
	
	}, _css2['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		paddingBottom: '0',
		background: 'none'
	}, _css2));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px'
	});

/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _headerManager = __webpack_require__(31);
	
	var _myselfBg = __webpack_require__(366);
	
	var _myselfBg2 = _interopRequireDefault(_myselfBg);
	
	var _someoneIKnowBg = __webpack_require__(367);
	
	var _someoneIKnowBg2 = _interopRequireDefault(_someoneIKnowBg);
	
	var _screener = __webpack_require__(1071);
	
	var _cards = __webpack_require__(17);
	
	var _colouredCard = __webpack_require__(61);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScreenerPage = function (_React$PureComponent) {
		_inherits(ScreenerPage, _React$PureComponent);
	
		function ScreenerPage() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, ScreenerPage);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.componentDidMount = function () {
				_headerManager.HeaderManager.headerProperties = {};
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		ScreenerPage.prototype.render = function render() {
			var _ref;
	
			var pageSettings = this.props.data.page.edges[0].node;
	
			return _react2.default.createElement(
				'div',
				{ className: _screener.wrapperStyle },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: pageSettings.heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: pageSettings.heading })
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)('#fff') },
					_react2.default.createElement(
						'div',
						{ className: _screener.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _screener.titleStyle },
								pageSettings.heading
							)
						),
						_react2.default.createElement('div', {
							className: _screener.textStyle,
							dangerouslySetInnerHTML: {
								__html: pageSettings.body
							}
						})
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _screener.cardsWrapStyle },
					_react2.default.createElement(
						'div',
						{ className: _screener.innerWrapperStyle },
						_react2.default.createElement(
							'section',
							{ className: _screener.cardsSectionStyle },
							_react2.default.createElement(
								_cards.Cards,
								{
									columns: 2,
									scrollable: false,
									columnsAt: (_ref = {}, _ref['max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint] = 1, _ref)
								},
								_react2.default.createElement(_colouredCard.ColouredCard, {
									id: 0,
									to: '/screener/for-myself',
									background: '#F5A81E url(' + _myselfBg2.default + ') no-repeat bottom right',
									minHeight: 210,
									title: pageSettings.consumer_tile_label,
									arrow: true
								}),
								_react2.default.createElement(_colouredCard.ColouredCard, {
									id: 1,
									to: '/screener/carer',
									background: '#F26C22 url(' + _someoneIKnowBg2.default + ') no-repeat bottom right',
									minHeight: 210,
									title: pageSettings.carer_tile_label,
									arrow: true
								})
							)
						)
					)
				)
			);
		};
	
		return ScreenerPage;
	}(_react2.default.PureComponent);
	
	ScreenerPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						consumer_tile_label: _propTypes2.default.string.isRequired,
						carer_tile_label: _propTypes2.default.string.isRequired
					}).isRequired
				})).isRequired
			}).isRequired
		}).isRequired
	};
	exports.default = ScreenerPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-screener-index-js-4fea7ac9aa520640177f.js